'use strict';

var buildDateRangeUnits = require('../internal/buildDateRangeUnits');

buildDateRangeUnits();


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/build/buildDateRangeUnitsCall.js
// module id = 391
// module chunks = 0